<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> قرارداد ها </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <!-- جدول اطلاعات -->

    <div class="border border-2 p-2">

        <div class="row gx-2 gy-md-0 gy-2">

            <!-- اینپوت جستجو -->

            <div class="col-12 col-md-10">

                <input class="w-100 form-control" placeholder="جستجو کنید ..." (keyup)="filter_list($event.target)">

            </div>

            <div class="col-12 col-md-auto" *ngIf="accessibility('bMadonik_ServiceContract_Save')">

                <button class="btn btn-success w-100" (click)="openModal()">

                    &nbsp; افزودن &nbsp;

                </button>

            </div>

        </div>

        <div class="section border border-2 mt-2" style="max-height:calc(100vh - 230px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead class="">

                    <tr class="">

                        <th class="text-center"> # </th>

                        <th class="text-center"> عملیات </th>

                        <th class="text-center"> شماره </th>

                        <th class="text-center"> تاریخ </th>

                        <th class="text-center"> وضعیت </th>

                        <th class="text-center"> مدرسه </th>

                        <th class="text-center"> دانش آموز </th>

                        <th class="text-center"> موبایل </th>

                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Result; let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <td class="">

                            <i class="fa fa-eye fa-lg pointer" title="مشاهده" (click)="openViewModal(item,i)"></i>

                            <i class="fa fa-edit fa-lg text-primary mx-2 pointer"

                                *ngIf="accessibility('bMadonik_ServiceContract_Edit')"
                            
                                title=" ویرایش" (click)="openEditModal(item,i)">
                            
                            </i>

                            <i class="fa fa-trash fa-lg text-danger pointer" 

                                *ngIf="accessibility('bMadonik_ServiceContract_Delete')"
                            
                                title="حذف" (click)="removeItem(item,i)">
                            
                            </i>

                        </td>

                        <td> {{ item.iMadonik_ServiceContract | faNum }} </td>

                        <td> {{ item.strDate | faNum }} </td>

                        <td> {{ item.strMadonik_ContractStatus_strComment | faNum }} </td>

                        <td> {{ item.strMobileDomain_strComment | faNum }} </td>

                        <td> {{ item.strPassenger_FullName | faNum }} </td>

                        <td> {{ item.strMobile | faNum }} </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>

<div class="modal fade" id="AddOrEdit_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> {{bViewMod ? 'مشاهده' : bEditMod ? 'ویرایش' : 'افزودن' }} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body" style="max-height: 74vh;overflow-y: auto;">

                <ng-container *ngIf="!bEditMod && !bViewMod">

                    <div [formGroup]="mdl_Search" class="row gx-0 gy-0 p-2">

                        <div class="position-relative col-10 p-2">

                            <label class="mb-2 text-muted"> کد ملی </label>

                            <input class="form-control p-2" maxlength="10"

                                (input)="mdl_Save.get('strMobile')?.setValue('');mdl_Save.get('iPassenger')?.setValue('')"

                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"

                                placeholder="کد ملی دانش آموز را وارد کنید" 
                                
                                formControlName="strNationalCode">

                        </div>

                        <div class="col-2 p-2">

                            <button class="btn btn-primary" (click)="searchStudent()">

                                جستجو

                            </button>

                        </div>

                    </div>

                </ng-container>

                <ng-container *ngIf="mdl_Save.get('strMobile')?.value">

                    <div [formGroup]="mdl_Save" class="row gx-0 gy-0 p-2">

                        <!-- نام خانوادگی -->

                        <div class="position-relative col-md-6 col-12 p-2" style="pointer-events: none;">

                            <label class="mb-2 text-muted"> نام خانوادگی </label>

                            <input class="form-control text-center p-2" formControlName="strPassenger_FullName" disabled>

                        </div>

                        <!-- موبایل -->

                        <div class="position-relative col-md-6 col-12 p-2" style="pointer-events: none;">

                            <label class="mb-2 text-muted"> موبایل </label>

                            <input class="form-control text-center p-2" formControlName="strMobile" disabled>

                        </div>

                        <!-- مدرسه -->

                        <div class="position-relative col-md-6 col-12 p-2" style="pointer-events: none;">

                            <label class="mb-2 text-muted"> مدرسه </label>

                            <input class="form-control text-center p-2" formControlName="strMobileDomain_strComment" disabled>

                        </div>

                        <!-- شماره قرارداد -->

                        <div class="position-relative col-md-6 col-12 p-2">

                            <label class="mb-2 text-muted"> شماره قرارداد </label>

                            <input class="form-control text-center p-2" formControlName="strContactNo">

                        </div>

                        <!-- وضعیت -->

                        <div class="position-relative col-md-6 col-12 p-2">

                            <label class="mb-2 text-muted"> وضعیت </label>

                            <select class="form-select p-2" formControlName="tiMadonik_ContractStatus">

                                <option class="text-center" value=""> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_ContractStatus" [value]="item.tiMadonik_ContractStatus">

                                    {{item.strComment}}

                                </option>

                            </select>

                        </div>

                        <!-- نوع خودرو -->

                        <div class="position-relative col-md-6 col-12 p-2">

                            <label class="mb-2 text-muted"> نوع خودرو </label>

                            <select class="form-select p-2" formControlName="tiMobileType">

                                <option class="text-center" value=""> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_GroupCar" [value]="item.tiMobileType">

                                    {{item.strComment}}

                                </option>

                            </select>

                        </div>

                        <!-- از تاریخ -->

                        <div class="position-relative col-md-6 col-12 p-2">

                            <label> از تاریخ </label>

                            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                                [dateGregorianFormat]="'YYYY/MM/DD'" [dateInitValue]="true"
                                [dateFormat]="'jYYYY/jMM/jDD'">

                                <input type="text" formControlName="strSDate" placeholder="از تاریخ"
                                    class="form-control text-end p-2" />

                            </ng-persian-datepicker>

                        </div>

                        <!-- تا تاریخ -->

                        <div class="position-relative col-md-6 col-12 p-2">

                            <label> تا تاریخ </label>

                            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                                [dateGregorianFormat]="'YYYY/MM/DD'" [dateInitValue]="true"
                                [dateFormat]="'jYYYY/jMM/jDD'">

                                <input type="text" formControlName="strEDate" placeholder="تا تاریخ"
                                    class="form-control text-end p-2" />

                            </ng-persian-datepicker>

                        </div>

                        <!-- مبلغ قرارداد -->

                        <div class="position-relative col-md-6 col-12 p-2">

                            <label class="mb-2 text-muted"> مبلغ قرارداد(ریال) </label>

                            <input class="form-control text-center p-2"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                formControlName="iContractAmount">

                        </div>

                        <!-- مبلغ پرداخت شده -->

                        <div class="position-relative col-md-6 col-12 p-2">

                            <label class="mb-2 text-muted"> مبلغ پرداخت شده(ریال) </label>

                            <input class="form-control text-center p-2"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                formControlName="iAmountPaid">

                        </div>

                        <!-- شرایط پرداخت -->

                        <div class="position-relative col-12 p-2">

                            <label class="mb-2 text-muted"> شرایط پرداخت </label>

                            <textarea style="height: 50px;resize: none;" class="form-control" formControlName="strPaymentTerms"></textarea>

                        </div>

                        <!-- توضیحات -->

                        <div class="position-relative col-12 p-2">

                            <label class="mb-2 text-muted"> توضیحات </label>

                            <textarea style="height: 100px;resize: none;" class="form-control" formControlName="strDetail"></textarea>

                        </div>

                    </div>

                </ng-container>

                <ng-container *ngIf="mdl_Save.get('iPassenger')?.value == '0' ">

                    <app-new-student [isContracts]="true" (closeModal)="onSubmit_Student($event)"></app-new-student>

                </ng-container>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <ng-container *ngIf="mdl_Save.get('strMobile')?.value && !bViewMod">

                    <button class="btn btn-success" (click)="submitRequest()">

                        &nbsp; {{ bEditMod ? 'ویرایش' : 'ثبت' }} &nbsp;

                    </button>

                </ng-container>

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>